import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./store";
import App from "./App";
import { ProSidebarProvider } from 'react-pro-sidebar';
import { PersistGate } from 'redux-persist/integration/react';
import {persistStore} from 'redux-persist';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

let persistor = persistStore(store);

ReactDOM.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ProSidebarProvider>
          <GoogleReCaptchaProvider reCaptchaKey="6Lc3NnkqAAAAALUH-258R6D9rl0yQfgkkmESWkmC">
            <App />
          </GoogleReCaptchaProvider>
        </ProSidebarProvider>
      </PersistGate>
    </Provider>
  ,
  document.getElementById("root")
);
